/**
 * Der zuletzt angetippte Push, wie ihn sw.js im Cache ablegt. Die Seite holt
 * ihn ab, statt sich allein auf postMessage oder die geoeffnete URL zu
 * verlassen - beides geht in der installierten iPhone-Web-App beim ersten
 * Tipp gern verloren (App startet auf der Startadresse, bzw. das Fenster im
 * Hintergrund wacht erst nach der Nachricht auf).
 */

const PENDING_CACHE = 'r2f-pending';
const PENDING_URL = '/__r2f/notification-click';
/** Aeltere Tipps sind kein Grund mehr, irgendwohin zu springen. */
const MAX_AGE_MS = 5 * 60 * 1000;

export interface NotificationClick {
  rideId: string;
  token: string | null;
  type: string | null;
}

let queue: Promise<unknown> = Promise.resolve();

/**
 * Liefert den abgelegten Tipp genau einmal und loescht ihn dabei. Aufrufe
 * laufen nacheinander, damit Start, Sichtbarwerden und postMessage denselben
 * Tipp nicht doppelt verarbeiten.
 */
export function takeNotificationClick(): Promise<NotificationClick | null> {
  const next = queue.then(async (): Promise<NotificationClick | null> => {
    if (typeof caches === 'undefined') return null;
    try {
      const cache = await caches.open(PENDING_CACHE);
      const response = await cache.match(PENDING_URL);
      if (!response) return null;
      await cache.delete(PENDING_URL);
      const data = await response.json();
      if (typeof data?.rideId !== 'string') return null;
      if (typeof data.at === 'number' && Date.now() - data.at > MAX_AGE_MS) return null;
      return {
        rideId: data.rideId,
        token: typeof data.token === 'string' ? data.token : null,
        type: typeof data.type === 'string' ? data.type : null,
      };
    } catch {
      return null;
    }
  });
  queue = next;
  return next;
}
